import state from '@/taskpane/state/sidebar-state'
import MessageArgs from '../messages/message-args'
import sendItemOpenMessage from '../messages/send-item-open-message'

interface SidebarConnectedArgs extends MessageArgs {
  authenticated: boolean
}

export default async function sidebarConnectedHandler(data: SidebarConnectedArgs) {
  state.sidebarIsConnected = true
  state.sidebarIsAuthenticated = data.authenticated

  if (state.cirrusToken) {
    await sendItemOpenMessage()
  }
}
